export function Footer() {
  return (
    <footer
      data-id="site-footer"
      className="relative bottom-0 z-[1] bg-[var(--black-50)] p-[1em]"
    >
      <p>© PLAYBRAIN Inc All Rights Reserved</p>
    </footer>
  )
}

export default Footer
